// Generated by purs version 0.11.7
"use strict";
var $foreign = require("./foreign");
var Control_Monad_Eff = require("../Control.Monad.Eff");
var Data_Unit = require("../Data.Unit");
var Prelude = require("../Prelude");
var modifyRef = function (ref) {
    return function (f) {
        return $foreign["modifyRef'"](ref)(function (s) {
            return {
                state: f(s),
                value: Data_Unit.unit
            };
        });
    };
};
module.exports = {
    modifyRef: modifyRef,
    newRef: $foreign.newRef,
    readRef: $foreign.readRef,
    "modifyRef'": $foreign["modifyRef'"],
    writeRef: $foreign.writeRef
};



//////////////////
// WEBPACK FOOTER
// ./output/Control.Monad.Eff.Ref/index.js
// module id = 270
// module chunks = 0